import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/devices',
      name: 'devices',
      component: resolve => require(['@/components/devices'], resolve)
    },
    {
      path: '/current',
      name: 'current',
      component: resolve => require(['@/components/current'], resolve)
    },
    {
      path: '/add',
      name: 'add',
      component: resolve => require(['@/components/add'], resolve)
    },
    {
      path: '/config',
      name: 'config',
      component: resolve => require(['@/components/config'], resolve)
    },
    {
      path: '/xfconfig',
      name: 'xfconfig',
      component: resolve => require(['@/components/xfconfig'], resolve)
    },
    {
      path: '/help',
      name: 'help',
      component: resolve => require(['@/components/help'], resolve)
    },
    {
      path: '/city',
      name: 'city',
      component: resolve => require(['@/components/city'], resolve)
    },
    {
      path: '/airkiss',
      name: 'airkiss',
      component: resolve => require(['@/components/airkiss'], resolve)
    },
    {
      path: '/auth',
      name: 'auth',
      component: resolve => require(['@/components/auth'], resolve)
    }, {
      path: '/dash2023/:sn',
      name: 'dash2023',
      component: resolve => require(['@/components/dashboard'], resolve)
    }, {
      path: '/dash/:sn',
      name: 'dash',
      component: resolve => require(['@/components/dash'], resolve)
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js